"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MODE;
(function (MODE) {
    MODE["VIRTUAL"] = "virtual";
    MODE["FAKE"] = "fake";
    MODE["NATIVE"] = "native";
})(MODE = exports.MODE || (exports.MODE = {}));
var DIRECTION;
(function (DIRECTION) {
    DIRECTION[DIRECTION["UP"] = 1] = "UP";
    DIRECTION[DIRECTION["DOWN"] = -1] = "DOWN";
    DIRECTION[DIRECTION["INITIAL"] = 0] = "INITIAL";
})(DIRECTION = exports.DIRECTION || (exports.DIRECTION = {}));
var TRACK;
(function (TRACK) {
    TRACK["X"] = "x";
    TRACK["Y"] = "y";
})(TRACK = exports.TRACK || (exports.TRACK = {}));
